export default "__VITE_ASSET__DfRYoHz___"